import $ from 'jquery';

import whenDomReady from 'when-dom-ready';
import ViewGlobal from './views/view-global';

export default async () => {

    let $body = $('body');

    if ($body.hasClass('template-index')) {
        await import(/* webpackMode:"eager", webpackChunkName: "page-home" */ './pages/page-home');
    }
    
    if ($body.hasClass('template-product')) {
        await import(/* webpackMode:"eager", webpackChunkName: "page-product" */ './pages/page-product');
    }
    
    if ( ($body.hasClass('template-collection') || $body.hasClass('template-search')) && $body.data('tempsuffix') != 'lookbook' ) {
        await import(/* webpackMode:"eager", webpackChunkName: "collection" */ './pages/page-collection');
    }
    
    if ($body.hasClass('template-giftcard')) {
        await import(/* webpackMode:"eager", webpackChunkName: "giftcard" */ './pages/page-giftcard');
    }

    if ($body.hasClass('template-cart')) {
        await import(/* webpackMode:"eager", webpackChunkName: "cart" */ './pages/page-cart');
    }
    
    if ($body.data('tempsuffix') == 'styles') {
        await import(/* webpackMode:"eager", webpackChunkName: "page.styles" */ './pages/page-styleGuide');
    }
    
    if ($body.data('tempsuffix') == 'about') {
        await import(/* webpackMode:"eager", webpackChunkName: "page.about" */ './pages/page-about');
    }
    
    if ($body.data('tempsuffix').includes('utility')) {
        require('./pages/page-utility');
    }

    if ($body.hasClass('template-404')) {  
        await import(/* webpackMode:"eager", webpackChunkName: "404" */ './pages/page-404');
    }
    
    if ($body.hasClass('template-blog')) {
        await import(/* webpackMode:"eager", webpackChunkName: "blog" */ './pages/page-blog');
    }

    if ($body.hasClass('template-article')) {
        await import(/* webpackMode:"eager", webpackChunkName: "article" */ './pages/page-article');
    }

    if ($body.data('tempsuffix').includes('multisection')) {
        require('./pages/page-multisection');
        require('./pages/page-home');
    }
    
    if ($body.hasClass('page-account') 
        || $body.hasClass('page-create-account') 
        || $body.hasClass('page-reset-account') 
        || $body.hasClass('page-addresses') 
    ) {
        await import(/* webpackMode:"eager", webpackChunkName: "customers" */ './pages/page-account');
    }

    if ($body.hasClass('template-password')
        || $body.hasClass('template-page') && $body.hasClass('template-suffix-update-password')
    ) {
        await import(/* webpackMode:"eager", webpackChunkName: "page-password" */ './pages/page-password');
    }

    if ($body.data('tempsuffix') == 'store-locator') {
        await import(/* webpackMode:"eager", webpackChunkName: "page.store-locator" */ './pages/page-storeLocator');
    }

    whenDomReady(() => {
        if (!$body.hasClass('template-password')) {
            ORW.Global = new ViewGlobal({el: $body});
        }
    });

};